import React from 'react';

export default function SectionHeader({ eyebrow, title, subtitle, center = true }) {
  return (
    <div className={`mb-8 md:mb-14 ${center ? 'text-center' : ''}`}>
      {eyebrow && (
        <span className="inline-block mb-3 text-xs font-black tracking-widest uppercase text-brand-purple">
          {eyebrow}
        </span>
      )}
      <h2 className="font-display font-black tracking-tight leading-tight mb-4
                     text-3xl md:text-5xl text-ink-900">
        {title}
      </h2>
      {subtitle && (
        <p className="text-ink-500 text-lg max-w-2xl mx-auto leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
